// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1-WIg","content":"LayoutSettings_content__1PUpb"};